import Button from '@wg/wows-react-uikit/Button'
import ButtonGroup from '@wg/wows-react-uikit/ButtonGroup'
import Currency from '@wg/wows-react-uikit/Currency'
import DialogBody from '@wg/wows-react-uikit/DialogBody'
import DialogFooter from '@wg/wows-react-uikit/DialogFooter'
import DialogHeader from '@wg/wows-react-uikit/DialogHeader'
import Message from '@wg/wows-react-uikit/Message'
import Link from '@wg/wows-react-uikit/Link'
import React, { Fragment, PureComponent } from 'react'
import { Interpolate } from 'react-i18next'
import { TRANSACTIONS_STATUSES } from '../../../Actions/ActionTreasury'
import { t, x } from '../../../helpers/localization'
import styles from './TransactionDetailDialog.scss'
import get from 'lodash/get'

type Member = {
    name: string,
    roleName: string,
}

export type IProps = {

    detailViewTransaction: Transaction,
    members: Array<any>,

    hideDistributionResultDialog: () => void,
    repeatFailedDistribution: () => void,
}

export type IState = {
    showAll: boolean
}

class TransactionDetailDialog extends PureComponent<IProps, IState> {

    state = {
        showAll: false,
    }

    toggleShowAll = () => {
        this.setState({
            showAll: !this.state.showAll,
        })
    }

    getUserNames = () => {
        const names = []
        if (this.props.detailViewTransaction.data.receivers) {
            this.props.detailViewTransaction.data.receivers.forEach((receiver: Receiver) => {
                names.push(receiver.player.name)
            })
        }
        if (this.state.showAll) {
            return names.join(', ')
        } else {
            return names.slice(0, 3).join(', ')
        }

    }

    renderDistributionSumm = () => {

        const firstDelta = (this.props.detailViewTransaction.data.receivers && this.props.detailViewTransaction.data.receivers[0]) ? this.props.detailViewTransaction.data.receivers[0].delta : { type: 'oil', amount: 0 }
        const isManyReceivers = this.props.detailViewTransaction.data.receivers ? this.props.detailViewTransaction.data.receivers.length > 3 : false
        const moreThanOne = this.props.detailViewTransaction.data.receivers ? this.props.detailViewTransaction.data.receivers.length > 1 : false

        return (
            <Interpolate
                i18nKey={x('%(title)s %(amount)s %(players)s %(names)s %(showAll)s')}
                title={moreThanOne ? (
                    <span>
                        {t('Начисление по ')}
                    </span>
                ) : (
                        <span>
                            {t('Начисление ')}
                        </span>
                    )}
                amount={(
                    <Currency
                        amount={firstDelta.amount}
                        isBold={true}
                        type={Currency.types[firstDelta.type]}
                        t={t}
                    />
                )}
                players={moreThanOne ? (
                    <span>
                        {t(' игрокам: ')}
                    </span>
                ) : (
                        <span>
                            {t(' игроку: ')}
                        </span>
                    )}
                names={this.getUserNames()}
                showAll={isManyReceivers ? this.state.showAll ? (
                    <Link isActionLink={false} arrow={''} onClick={this.toggleShowAll}>
                        {t(' скрыть')}
                    </Link >
                ) : (
                        <Link isActionLink={false} arrow={''} onClick={this.toggleShowAll}>
                            {t(' показать всех ')}
                        </Link >
                    ) : null}
                className={styles.distributionCell}
            />
        )
    }

    renderTransactionStatusMessage = () => {

        const failedReceivers = this.props.detailViewTransaction.data.failedReceivers

        switch (this.props.detailViewTransaction.status) {
            case TRANSACTIONS_STATUSES.FAILED: {
                return (
                    <div className={styles.statusMessage}>
                        {t('Распределение ресурсов не прошло. Все распределяемые ресурсы возвращены в казну клана.')}
                    </div>
                )

            }
            case TRANSACTIONS_STATUSES.PENDING: {
                return (
                    <div className={styles.statusMessage}>
                        {t('Выполняется распределение ресурсов. ')}
                    </div>
                )
            }
            case TRANSACTIONS_STATUSES.COMPLETED: {

                if (failedReceivers.length > 0) {
                    return (
                        <Fragment>
                            <div className={styles.statusMessage}>
                                {t('Распределение ресурсов частично прошло успешно, но следующие игроки не получили ресурсы:')}
                            </div>
                            {this.renderFailedReceivers()}
                            <span className={styles.failedReceiversMessage}>{t('Предназначавшиеся им ресурсы возвращены в казну клана.')}</span>
                        </Fragment>
                    )
                } else {
                    return (
                        <div className={styles.statusMessage}>
                            {t('Распределение ресурсов прошло успешно.')}
                        </div>
                    )
                }

            }
            default: {
                return null
            }
        }
    }

    renderFailedReceivers = () => {
        const failedReceivers = this.props.detailViewTransaction.data.failedReceivers

        if (failedReceivers && failedReceivers.length > 0) {
            return (
                <div className={styles.failedReceivers}>
                    {failedReceivers.map((item, index) => {
                        let member: Member = this.props.members.filter((m) => m.id === item)[0]

                        let name = ''
                        let role = ''
                        if (member) {
                            name = `${member.name}`
                            role = `${member.roleName}`
                        }

                        return (
                            <span
                                className={styles.failedReceiverName}
                                key={`failedReceiver${index}`}
                            >
                                {`${name},`}
                            </span>
                        )
                    })}
                </div>
            )
        }

        return null
    }

    getFailedPlayerNames = (transaction, isChildTransaction) => {
        const failedReceivers = get(transaction, 'data.failedReceivers', [])
        const initiallyFailedReceivers = get(transaction, 'data.initiallyFailedReceivers', [])

        if (initiallyFailedReceivers) {
            const failedReceiverNames = this.props.members.filter(member => failedReceivers.includes(member.id)).map(member => member.name)
            const initiallyFailedReceiverNames = initiallyFailedReceivers.map(member => member.name)
            return [...failedReceiverNames, initiallyFailedReceiverNames]
        }

        if (isChildTransaction || failedReceivers.length > 0) {
            return this.props.members.filter(member => failedReceivers.includes(member.id)).map(member => member.name)
        } else {
            const successReceivers = transaction.data.receivers.map(receiver => receiver.player.id)
            return this.props.members.filter(member => !successReceivers.includes(member.id)).map(member => member.name)
        }
    }

    repeatTreasuryBoxTransaction = (transaction) => () => {
        console.log(transaction.id)
        this.props.repeatTreasuryBoxTransaction(transaction.id)
        this.props.hideDistributionResultDialog()
    }

    render() {
        let transaction = this.props.detailViewTransaction
        let isChildTransaction = false
        if (this.props.detailViewTransaction.childTransactions && this.props.detailViewTransaction.childTransactions.length > 0) {
            transaction = this.props.detailViewTransaction.childTransactions[0]
            isChildTransaction = true
        }
        const isRewardsDistribution = transaction.operation === 'rewards_distribution'
        const isFailed = transaction.status === 'failed'
        const isSuccess = transaction.status === 'completed'
        const playerNames = this.getFailedPlayerNames(transaction, isChildTransaction)
        const rewardTitle = get(this.props, 'reward.title', '')

        let canRepeat = (transaction.data.failedReceivers && transaction.data.failedReceivers.length > 0) && !isFailed

        return (
            <Fragment>
                <DialogHeader>{isRewardsDistribution ? t('Приобретение награды') : t('Распределение ресурсов')}</DialogHeader>
                {isRewardsDistribution ? (
                    <DialogBody>
                        {isSuccess ? (
                            <div className={styles.grey}>
                                <Interpolate
                                    i18nKey={x('Приобретение награды «%(reward)s» выполнено успешно')}
                                    reward={rewardTitle}
                                />
                            </div>
                        ) : null}
                        <div className={styles.grey}>
                            {(playerNames.length > 0) ? (
                                <React.Fragment>
                                    {t('Контейнеры не были начислены игрокам: ')}
                                    {playerNames.map((name, index) => {
                                        const isLast = index === playerNames.length - 1
                                        return (
                                            <div style={(index === 0) ? { marginLeft: '6px' } : {}} className={styles.white} key={`Player-${name}`} >
                                                {`${name}`}{isLast ? null : ','}
                                            </div>
                                        )
                                    })}
                                </React.Fragment>
                            ) : null}
                        </div>
                    </DialogBody>
                ) : (
                        <DialogBody >
                            {this.renderDistributionSumm()}
                            {this.renderTransactionStatusMessage()}
                        </DialogBody>
                    )}
                <DialogFooter>
                    <ButtonGroup>
                        <Button onClick={this.props.hideDistributionResultDialog}>
                            {t('Закрыть')}
                        </Button>
                        {canRepeat ? (
                            <Button onClick={isRewardsDistribution ? this.repeatTreasuryBoxTransaction(transaction) : this.props.repeatFailedDistribution}>
                                {t('Распределить еще раз')}
                            </Button>
                        ) : null}
                    </ButtonGroup>
                </DialogFooter>
            </Fragment>
        )
    }
}

export default TransactionDetailDialog